import React, { Dispatch, MouseEventHandler, SetStateAction } from "react";
import RcDropdown from "rc-dropdown";
import "rc-dropdown/assets/index.css";
import i18n from "../../i18n";
import "./Dropdown.css";
interface IMenuItem {
  className?: string;
  onClick?: MouseEventHandler<any>;
  icon?: string;
  label?: string;
  hide?: boolean;
  key?: string | number;
}

interface DropdownProps {
  children: React.ReactNode;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  menuItems?: IMenuItem[];
  overlay?: any;
  trigger?: ("click" | "hover" | "contextMenu")[];
  placement?:
    | "bottomLeft"
    | "bottomCenter"
    | "bottomRight"
    | "topLeft"
    | "topCenter"
    | "topRight";
  className?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  children,
  isOpen,
  setIsOpen,
  overlay,
  menuItems,
  trigger = ["click"],
  placement = "bottomLeft",
  className,
}) => {
  const builtOverlay = (
    <div className={`rounded-lg bg-white p-2 shadow-md ${className}`}>
      {overlay ??
        menuItems?.map((item, index) => {
          return (
            !item?.hide && (
              <div
                key={index}
                onClick={(event) => {
                  setIsOpen(false);
                  item?.onClick && item?.onClick(event);
                }}
                className={`text-primary-textFont z-30 flex w-full cursor-pointer items-center gap-2 rounded-md p-2 hover:bg-systemBg ${item?.className}`}
              >
                <p className="flex gap-3 text-sm">
                  {item?.icon && (
                    <img className="w-5" src={item?.icon} alt={item?.label} />
                  )}
                  {item?.label}
                </p>
              </div>
            )
          );
        })}
    </div>
  );
  const lang = i18n.language?.slice(0, 2);

  return (
    <RcDropdown
      overlay={builtOverlay}
      trigger={trigger}
      overlayClassName={lang == "ar" ? "arabic" : ""}
      placement={placement as any}
      visible={isOpen}
      onVisibleChange={(visible) => setIsOpen(visible)}
    >
      <div className="inline-block">{children}</div>
    </RcDropdown>
  );
};

export default Dropdown;
